module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Set in a Silver Sea")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter02"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Evidence from Bodies")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" The Languages of Britain")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Conquest and Pacification")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Romanisation and Conflict")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Climate Change and Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Crisis in the Third Century")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" Britain in the Dominate")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" The Archaeology of Collapse")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Tying it all Together into a Narrative")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Final",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Final Thoughts")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Time",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Line")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0